export const CHART_CONFIG = {
  layout: {
    margin: {
      l: 60,
      r: 50,
      b: 50,
      t: 50,
      pad: 4
    },
    hovermode: 'x unified',
    hoverlabel: {
      namelength: -1
    },
    xaxis: {
      linecolor: '#000000',
      autorange: true,
      tickformat: '%d.%m.%Y\n %H:%M',
      tickfont: {
        size: 10
      },
      spikecolor: '#ff0000',
      spikethickness: 2,
      spikedash: 'solid'
    },
    yaxis: {
      linecolor: '#000000',
      autorange: true,
      tickfont: {
        size: 10
      }
    }
  },
};

export const TABLE_COLUMNS = [
  {
    header: 'Добавить',
    field: 'is_visible',
    bodyStyle: 'text-align: center; width:70px;',
    headerStyle: 'width:70px',
    dataType: { type: 'Checkbox' },
    editor: { type: 'Checkbox', attrList: { binary: true } }
  },
  {
    header: 'Цвет',
    field: 'color',
    dataType: { type: 'ColorPicker' },
    editor: { type: 'ColorPicker' },
    bodyStyle: 'text-align: center; width:70px;',
    headerStyle: 'width:70px'
  },
  {
    header: 'Отобразить',
    field: 'isVisibleForm',
    bodyStyle: 'text-align: center; width:80px;',
    sortable: true,
    dataType: { type: 'Checkbox' }
  },
  {
    header: 'Свойства',
    field: 'typeName',
    sortable: true
  },
  {
    header: 'Описание',
    field: 'desc',
    sortable: true
  },
  {
    header: 'Фл №',
    field: 'flangeNo',
    bodyStyle: 'text-align: center',
    headerStyle: 'width:80px'
  },
  {
    header: 'Расч. значение',
    field: 'outputValue',
    bodyStyle: 'text-align: right;',
    sortable: true,
    dataType: { type: 'Number' }
  },
  {
    header: 'Значение',
    field: 'value',
    bodyStyle: 'text-align: right;',
    sortable: true,
    dataType: { type: 'Number' }
  },
  {
    header: 'Дата с ист.',
    field: 'date',
    sortable: true,
    dataType: { type: 'Date' }
  },
  {
    header: 'Ед. изм',
    field: 'unitShortName',
    sortable: true
  },
  {
    header: 'Состояние',
    field: 'state'
  },
  {
    header: 'Событие',
    field: 'is_event',
    bodyStyle: 'text-align: center; width:80px;',
    sortable: true,
    dataType: { type: 'Checkbox' }
  }
];
export const TABLE_TEMP_COLUMNS = [
  {
    header: 'ID',
    field: 'property_log_id',
    bodyStyle: "text-align: right;"
  },
  {
    header: 'Значение',
    field: 'property_value',
    bodyStyle: "text-align: right;"
  },
  {
    header: 'Расч. значение',
    field: 'property_outvalue',
    bodyStyle: "text-align: right;"
  },
  {
    header: 'Время накоп., мин',
    field: 'property_accum_duration_minute',
    bodyStyle: "text-align: right;"
  },
  {
    header: 'Время',
    field: 'property_log_date',
  }
]